<template>
  <div v-if="vorgeschlageneDiagnose">
    <div id="vorgeschlagene">
      Vorgeschlagene Diagnose: <b> {{ vorgeschlageneDiagnose["DIAGNOSE"] }}</b>
    </div>
  </div>
  <div style="margin: 20px; background-color: lightgray" v-else>
    KEIN DIAGNOSTIK VORHANDEN;
    Fehlermeldung weil nicht in Tabelle klassifiziert!
    BITTE Durchführen einer EEG, MRT oder CCT
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import infoTexte from "../../../js/clinical-algorithm/infoTexte/infoTexte";

export default {
  name: "VorgeschlageneDiagnoseComponent",
  computed: {
    ...mapGetters('cdss/diagnosestellung', [
      'vorgeschlageneDiagnose'
    ]),
    infoVorgeschlageneDiagnose: () => infoTexte.diagnosestellungTopRight
  }
}
</script>

<style scoped>
#vorgeschlagene {
  font-size: 20pt;
  margin: 20px;
}

</style>
